import { RootState } from '..';

export const hasEpisodeRecommendations = (state: RootState) =>
    state.player.recommendedEpisodes.length > 0;
